import { Contact, ContactType } from '@api/generated/graphql';
import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import { Link } from '@servicetitan/design-system';
import styles from './ContactMethodLink.module.css';
import ClickToCall from '@components/ClickToCall/ClickToCall';

interface ContactMethodLinkProps {
  contact: Contact;
  locator?: string;
  customTaskAttributes?: Record<string, unknown>;
}

/**
 * Renders a link containing the value of a contact method as a link.
 *
 */
const ContactMethodLink = ({
  contact,
  locator,
  customTaskAttributes,
}: ContactMethodLinkProps) => {
  const isPhoneOrMobileType =
    contact.type === ContactType.MobilePhone ||
    contact.type === ContactType.Phone;

  const isEmailType = contact.type === ContactType.Email;

  const contactValue = isPhoneOrMobileType
    ? maskPhoneNumber(contact.value)
    : contact.value;

  return (
    <ClickToCall
      element={(onClick) =>
        ContactMethodLinkElement({
          isEmailType,
          contactValue,
          contact,
          locator,
          onClick,
        })
      }
      contact={contact}
      customTaskAttributes={customTaskAttributes}
    />
  );
};

const ContactMethodLinkElement = ({
  isEmailType,
  contactValue,
  contact,
  locator,
  onClick,
}: {
  isEmailType: boolean;
  contactValue: string;
  contact: Contact;
  locator?: string;
  onClick: () => void;
}) => (
  <Link
    href={isEmailType ? `mailto:${contact.value}` : undefined}
    className={`c-blue-500-i t-truncate ${styles.contactMethodLink}`}
    onClick={onClick}
    id={locator ? `${locator}-Link` : ''}
    target='_blank'
  >
    {contactValue}
  </Link>
);

export default ContactMethodLink;
